import { useEffect, useState } from "react";

import overviewIconWhite from "../assets/icons/invest_overview_white.svg";
import overviewIconGrey from "../assets/icons/invest_overview_grey.svg";
import exploreIconGrey from "../assets/icons/explore_products_grey.svg";
import exploreIconWhite from "../assets/icons/explore_producst_white.svg";
import { InvestSummary } from "./InvestSummary";
import InvestAvailableProduct from "./InvestAvailableProduct";
import InvestArbitrage from "./InvestArbitrage";
import InvestProperty from "./InvestProperty";
import InvestWithdraw from "./InvestWithdraw";
import InvestWithdrawDepositComplete from "./InvestWithdrawDepositComplete";
import { useAuth } from "../context/AuthContext";
import {
  useApplicationEntry,
  useAvailableAssets,
  useInvestmentEntry,
  useQueryUserBalance,
} from "../hooks/query/queries";
import Toaster from "../components/ui/toaster";
import InvestOwnedProduct from "./InvestOwnedProduct";

const InvestDashboardProductContent = ({
  productType,
  productId,
  ledgerId,
  applicationId,
}) => {
  console.log("applicationId", applicationId);
  const [dashType, setDashType] = useState("product");
  const [tab, setTab] = useState("overview");
  const [product, setProduct] = useState("Product X");
  const [isExploreDisabled, setIsExploreDisabled] = useState(false);
  const { user, userProfile } = useAuth();
  const authId = user?.sub || "";
  const { balance, isLoading: loading } = useQueryUserBalance(authId);
  const {
    data: ledgerProduct,

    isLoading: loadingProd,
    isError: errorProd,
  } = useInvestmentEntry(ledgerId);
  const {
    data: applicationProduct,
    isLoading: loadingAppProd,
    isError: appProdError,
  } = useApplicationEntry(applicationId);

  console.log("ledgerProduct", ledgerProduct);
  const asset =
    ledgerProduct?.productId?.assetId?.asset ||
    applicationProduct?.productId?.assetId?.asset;

  function changeToggle(data) {
    setTab(data);
  }
  const investArray = {
    id: userProfile?._id,
  };
  useEffect(() => {
    if (applicationProduct) {
      setIsExploreDisabled(true);
    }
  }, [applicationProduct]);
  const {
    data: assetsOwned,
    isLoading,
    errorOwnedAssets,
  } = useAvailableAssets({
    investArray,
  });
  console.log("assetsOwnedfromP", assetsOwned);

  return (
    <main>
      <Toaster />
      <InvestSummary
        dashType={dashType}
        product={ledgerProduct?.productId?.name}
        appProduct={applicationProduct?.productId?.name}
        userId={userProfile?._id}
      />

      <div className="px-20  py-7 bg-bg-light-gray rounded-t-2xl space-y-8 -translate-y-4 min-h-96">
        <div className="grid grid-cols-5 gap-4">
          <div className="flex flex-col px-6">
            <div
              className={
                tab == "overview"
                  ? "flex bg-gradient-to-r from-pink-500 to-purple-500 pl-6 py-4 mb-3 rounded-full hover:cursor-pointer"
                  : "flex pl-6 py-4 mb-3 rounded-full hover:cursor-pointer"
              }
              onClick={() => changeToggle("overview")}
            >
              <img
                src={tab == "overview" ? overviewIconWhite : overviewIconGrey}
                alt=""
                className="mr-3"
              />
              <p
                className={
                  tab == "overview"
                    ? "text-white text-[14px]"
                    : "text-text-secondary text-[14px]"
                }
              >
                Overview
              </p>
            </div>
            <div
              className={`flex pl-6 py-4 mb-3 rounded-full ${
                tab === "explore"
                  ? "bg-gradient-to-r from-pink-500 to-purple-500"
                  : isExploreDisabled
                    ? "bg-gray-200 cursor-not-allowed opacity-50"
                    : "hover:cursor-pointer"
              }`}
              onClick={() => {
                if (!isExploreDisabled) {
                  changeToggle("explore");
                }
              }}
            >
              <img
                src={
                  tab === "explore" && !isExploreDisabled
                    ? exploreIconWhite
                    : exploreIconGrey
                }
                alt=""
                className="mr-3"
              />
              <p
                className={`text-[14px] ${
                  tab === "explore" && !isExploreDisabled
                    ? "text-white"
                    : "text-text-secondary"
                }`}
              >
                Withdraw/Deposit
              </p>
            </div>
          </div>
          {(() => {
            if (tab == "overview") {
              return (
                <>
                  {productType == "asset" ? (
                    <InvestArbitrage productId={productId} />
                  ) : (
                    <InvestOwnedProduct
                      isExploreDisabled={isExploreDisabled}
                      productId={productId}
                      ledgerProduct={ledgerProduct || applicationProduct}
                      ledgerId={ledgerId}
                    />
                  )}
                </>
              );
            } else {
              return (
                <InvestWithdraw
                  ledgerId={ledgerId}
                  asset={asset}
                  assetsOwned={assetsOwned}
                  ledgerProduct={ledgerProduct || applicationProduct}
                />
              );
            }
          })()}
        </div>
      </div>
    </main>
  );
};

export default InvestDashboardProductContent;
